import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {clientInfoTypes} from '@constants/client-info.constants';
import {ClientInfo} from '@models/client-info.model';

@Injectable({
  providedIn: 'root'
})
export class ClientInfoService {

  constructor(
    private http: HttpClient
  ) {
  }

  private async getClientInfo(clientInfoType: string): Promise<ClientInfo> {
    const url = '/api/v1/client/info';
    const httpParams = new HttpParams().set('type', clientInfoType);
    return this.http.get<ClientInfo>(url, {params: httpParams}).toPromise();
  }

  async getPrivacy(): Promise<ClientInfo> {
    return this.getClientInfo(clientInfoTypes.PRIVACY_POLICY);
  }

  async getTerms(): Promise<ClientInfo> {
    return this.getClientInfo(clientInfoTypes.LEGAL_NOTICE);
  }
}
